<template>
	<article class="theme-update-page">
		<page-header />
		<theme-controller ref="theme" @submit="modify" />
		<div class="btn-wrap-main">
			<button
				type="button"
				class="btn-main"
				v-text="'미리보기'"
				@click="preview"
			/>
			<button
				form="theme"
				type="submit"
				class="btn-main blue"
				v-text="'수정'"
			/>
		</div>
	</article>
</template>
<script>
	import PageHeader from '@/components/PageHeader.vue';
	import ThemeController from '@/components/operation/ThemeController.vue';

	export default {
		name: 'ThemeUpdate',
		components: { PageHeader, ThemeController },
		data() {
			return {
				modified: false,
			};
		},
		mounted() {
			this.getThemeData();
		},
		async beforeRouteLeave(to, from, next) {
			if (!this.modified) {
				const hasChanges = this.$refs.theme.hasChanges();
				if (
					hasChanges &&
					confirm(
						'수정된 내용이 존재합니다. 수정 항목을 저장하시겠습니까?'
					)
				) {
					await this.$refs.theme.modify();
				}
			}
			next();
		},
		methods: {
			async getThemeData() {
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/theme/${this.$route.params.idTheme}`
				);
				this.$refs.theme.init(data);
			},
			preview() {
				this.$refs.theme.preview();
			},
			async modify() {
				const modifySuccess = await this.$refs.theme.modify();
				if (!modifySuccess) return;
				this.modified = true;
				this.$router.go(-1);
			},
		},
	};
</script>
